export const SCHEMA_CONSTANTS = {
    ALTERNATE_NAME: 'Zoopla Property Search',
    SCHEMA: 'http://schema.org',
    NAME: 'Zoopla',
    WEBSITE: 'WebSite',
    WEBPAGE: 'WebPage',
    LIST_ITEM: 'ListItem',
    BREADCRUMB_LIST: 'BreadcrumbList',
    REAL_ESTATE_AGENT: 'RealEstateAgent',
    POSTAL_ADDRESS: 'PostalAddress',
    RESIDENCE: 'Residence',
    IMAGE_OBJECT: 'ImageObject',
    GEO: 'GeoCoordinates',
    PERSON: 'Person',
    PLACE: 'Place'
};
